import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { DigitalRsvp } from '@zola/zola-ui/src/assets/images/icons';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

const HowItWorks = ({ onConfirm }) => (
  <div className={styles.container}>
    <CircleIcon image={DigitalRsvp} size={100} variant="cream" />
    <div className={styles.header}>How It Works</div>
    <div className={styles.content}>
      <ol className={styles.tipsList}>
        <li>Customize a digital design.</li>
        <li>We&apos;ll create a unique link to access your digital save the date.</li>
        <li>Copy and paste this link into a message-send through text, email, or DM!</li>
      </ol>
      <div className={styles.proTip}>
        <span role="img" aria-label="lightbulb">
          💡{' '}
        </span>
        Pro Tip: One link, all the power! Enable features directing guests to visit your wedding
        website and give their addresses.
      </div>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={onConfirm}>Got It</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(HowItWorks);
